import axios from "axios";

const BASE_URL = "https://api.ps-tube.com/";

export const fetchFromAPI = async (url) => {
  const { data } = await axios.get(`${BASE_URL}${url}`);
  return data;
};
